import { Avatar } from 'antd'
import type * as React from 'react'

interface UserAvatarProps {
  username: string
  size?: number
}

/**
 * A reusable user avatar component that displays the first letter of the username
 */
export function UserAvatar({ username, size = 32 }: UserAvatarProps) {
  return (
    <Avatar
      style={{
        backgroundColor: 'var(--theme-color-2-dim)',
        color: 'var(--theme-color-2)',
        textTransform: 'uppercase',
        flex: '0',
        minWidth: size,
      }}
      size={size}
    >
      {username.charAt(0)}
    </Avatar>
  )
}
